/* DocumentCounters.tsx
    Une page affichant la gestion des compteurs de documents
    Utilise le composant GenericCrudPage pour lister, ajouter, gérer et supprimer les compteurs de documents
    Utilise l'API correspondante pour les opérations de données
*/

import { DocumentCounterCrudCard } from 'features/documentCounters/components/DocumentCounterCrudCard';

export const DocumentCounters = () => (
	<div className="min-h-screen bg-gray-100 p-6">
		<DocumentCounterCrudCard
			size="lg"
			returnPath="/app/settings"
			returnLabel="Paramètres"
		/>
	</div>
);
